import { render, staticRenderFns } from "./site-view-trend-reports.vue?vue&type=template&id=d777358e&scoped=true"
import script from "./site-view-trend-reports.vue?vue&type=script&lang=ts"
export * from "./site-view-trend-reports.vue?vue&type=script&lang=ts"
import style0 from "./site-view-trend-reports.vue?vue&type=style&index=0&id=d777358e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d777358e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d777358e')) {
      api.createRecord('d777358e', component.options)
    } else {
      api.reload('d777358e', component.options)
    }
    module.hot.accept("./site-view-trend-reports.vue?vue&type=template&id=d777358e&scoped=true", function () {
      api.rerender('d777358e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/site-view/sections/site-view-trend-reports.vue"
export default component.exports